module.exports = __webpack_public_path__ + "static/media/bookworld_anders.c9d78ed4.jpg";